import { array, string, object, boolean } from '@gogame/schemas';

import {
  DAYS,
  RES,
  RE_ENGAGEMENT,
  IMPRESSION,
  CLICK,
  RECURRING,
} from './constants';

export const appsSchema = object({
  [DAYS]: string().required('Days is a required field'),
  [IMPRESSION]: string(),
  [CLICK]: string(),
  [RECURRING]: string(),
  [RES]: array(),
  [RE_ENGAGEMENT]: boolean().default(true),
});
